import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const DevTokensStore = GenericCollectionFactory("TOKENS", "uid");